<app-navbar></app-navbar>
<div class="container-fluid auto-height">
    <div class="row auto-height">
        <div class="col main-menu">
          <ul>
            <li class="module-wrapper">           
              <a routerLink="pulumi">
                <i class="fa-solid fa-gear"></i>
              </a>                 
            </li>
            <li class="module-wrapper">
              <a routerLink="whitelabel">
                <i class="fa-solid fa-mobile-screen-button"></i>
              </a>              
            </li>
            <li class="module-wrapper">
              <a routerLink="whatsapp">
                <i class="fa-brands fa-whatsapp"></i>
              </a>              
            </li>
          </ul>
        </div>
        <div class="col inner-shadow">
          <router-outlet></router-outlet>
        </div>
    </div>
</div>
